import { useEffect, useRef } from 'react';
import useConfetti from './useCanvas';

const items = [];
const path = new Path2D(
  'M16.54 8.498L9 16 1.5 8.54A4.944 4.944 0 010 4.987C0 2.232 2.243 0 5.013 0 6.63 0 8.083.763 9 1.959A5.019 5.019 0 0112.987 0C15.757 0 18 2.232 18 4.988a5.007 5.007 0 01-1.46 3.51',
);

const BuyBtnAnim = ({ onAnimationComplete, buyRef }) => {
  const btnc = useRef(null);
  const canvasRef = useConfetti(draw, onAnimationComplete);
  let currentTime = Date.now();

  useEffect(() => {
    if (buyRef.current) {
      btnc.current = findPos(buyRef.current);
      for (let i = 0; i < 90; i++) {
        items[i] = createParticle(window.innerWidth / 2, btnc.current.y, 10);
      }
    }
  }, []);

  function createParticle(x, y, minv) {
    const angle = Math.random() * (Math.PI / 2) + 15;
    const amount = Math.random() * 15.0 + minv;
    return {
      x,
      y,
      vx: Math.sin(angle) * amount,
      vy: Math.cos(angle) * amount,
      scale: getRandomFloat(0, 2),
      width: Math.random() * 20 + 8,
      height: Math.random() * 20 + 8,
      rotate: getRandomNonZeroNumber(),
      direction: Math.random() * 5 - 2.5,
      fallSpeed: Math.random() / 10 + 0.1,
    };
  }

  function getRandomNonZeroNumber() {
    return Math.random() * 133 - 30;
  }

  function getRandomFloat(min, max) {
    return Math.random() * (max - min) + min;
  }

  function findPos(obj) {
    const rect = obj.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2,
      y: rect.top,
    };
  }

  function draw(ctx, _canvas, alpha, ) {
    const time = Date.now();
    const delta = (time - currentTime) / (1000 / 40);
    currentTime = time;

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    items.forEach((item) => {
      item.vx *= 1.0 - 0.05 * delta;
      item.vy += delta * item.fallSpeed;
      item.vy /= 1.0 + 0.05 * delta;
      item.x += delta * item.vx;
      item.y += delta * item.vy;
      item.rotate += delta * item.direction;

      ctx.save();
      ctx.translate(item.x, item.y);
      ctx.scale(item.scale, item.scale);
      ctx.rotate((item.rotate * Math.PI) / 180);
      ctx.fill(path);
      ctx.restore();
    });
    ctx.globalAlpha = alpha;
  }

  return <canvas id="confetti" ref={canvasRef} />;
};

export default BuyBtnAnim;
